import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ChineseNewYear from './pages/ChineseNewYear';
import TX2years from './pages/TX2years';
import ToTheMoon from './pages/ToTheMoon';
import SportsDay from './pages/SportsDay';
import NY2024 from './pages/NY2024';
import NY2026 from './pages/NY2026';

function App(): JSX.Element {
  return (
    <div>
      <Routes>
        <Route path="/" element={<NY2026 />} />
      </Routes>
      <a
        href="/lucky-draw-web"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 1000,
          background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)',
          border: '2px solid #ff9a9e',
          color: '#444',
          padding: '10px 20px',
          borderRadius: '30px',
          textDecoration: 'none',
          fontWeight: 'bold',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          cursor: 'pointer',
        }}
      >
        Normal Mode
      </a>
    </div>
  );
}

export default App;
